module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fullscreen":"Fullscreen","start/stop":"Start/Stop","ignore":"Ignore","continue":"Continue","startover":"Startover","name":"Name","click behaviour":"Click behaviour","caption":"Caption","audio settings":"Audio Settings","autoplay":"Autoplay","mode":"Mode"}}')
  delete Component.options._Ctor
}
